import httpClient from '../httpClient.js';
import envService from '../environmentService';

const userHandler = {
  sso (ssoToken) {
    var url = `${this.getBaseUrl()}/sso/validate2`;
    return new Promise(function (resolve) {
      httpClient({
        method: 'get',
        url: url,
        headers: { 'token': ssoToken }
      }).then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          response.ok = false;
          resolve(response);
        }
      }).catch((e) => {
        let response = {
          code: 99,
          message: 'Unable to process request.'
        };

        resolve(response);
      });
    });
  },

  getBaseUrl () {
    var env = envService.getEnvironment();

    if (env === 'Local') {
      return 'https://userapi.hawksoft-dev.cloud';
    } else if (env === 'Development') {
      return 'https://userapi.hawksoft-dev.cloud';
    } else if (env === 'QA') {
      return 'https://userapi.hawksoft-qa.cloud';
    } else if (env === 'PO') {
      return 'https://userapi.hawksoft-po.cloud';
    } else if (env === 'Production') {
      return 'https://userapi.hawksoft.cloud';
    }

    return '<unable to determine user api url>';
  }

};

export {
  userHandler
};
